export const inspect = Symbol.for("nodejs.util.inspect.custom");
export const tag = Symbol("tag");
